import { TipoLicencia } from '../tipos/vacaciones';
import { API_ENDPOINTS } from '../config/apiConfig';
import { fetchJson } from './api';

/**
 * Obtiene todos los tipos de licencia.
 */
export function getAll(): Promise<TipoLicencia[]> {
  return fetchJson<TipoLicencia[]>(API_ENDPOINTS.tiposLicencia);
}
